export default __webpack_public_path__ + "static/media/AppOrder-ball.ec4be36c.png";